import { BaseContainerModel } from "../base-container.model";
import { bl_wms_picking_list_line_RowInterface, bl_wms_picking_list_line_RowClass } from "../../dbschema/index";

export class WMSPickingListLineContainer extends BaseContainerModel {
    bl_wms_picking_list_line: bl_wms_picking_list_line_RowInterface = new bl_wms_picking_list_line_RowClass();
}
